import { actions, reducer } from "./ducks";
import page from "./_SettingsPage/_SettingsPage";

import saga from "./saga";
import { Feature } from "features/interfaces";

export const settingsFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions,
  page
};
